import idb from 'idb';

class DB {

    constructor() {
        this.state = {
            name: 'Name',
            data: [],
        };

        this.dbPromise = idb.open('CF_DB', 1, updateDB => {

            var co = updateDB.createObjectStore('CF_Store', {
                keyPath: 'user_id',
                autoIncrement: true,
            });

            co.createIndex('user_id', 'user_id', {unique: false});

            return co;
        });

        this.orderPromise = idb.open('CF_Order', 1, updateDB => {

            var co = updateDB.createObjectStore('order_store');

            return co;
        });
    }

    getAll() {
        return this.dbPromise.then(db => {
            var tx = db.transaction('CF_Store', 'readonly');
            var store = tx.objectStore('CF_Store');

            return store.getAll();
        });
    }

    delete(key) {
        return this.dbPromise.then(db => {
            const tx = db.transaction('CF_Store', 'readwrite');
            tx.objectStore('CF_Store').delete(key);
            tx.objectStore('CF_Store').getAll();

            return tx.complete;
        });
    }

    getAllKeys() {
        return this.orderPromise.then(db => {
            const tx = db.transaction('order_store', 'readwrite');
            return tx.objectStore('order_store').getAllKeys();
        });
    }

    set(val) {
        return this.dbPromise.then(db => {
            const tx = db.transaction('CF_Store', 'readwrite');
            tx.objectStore('CF_Store').put(val);
            return tx.complete;
        });
    }

    getStore() {
        return this.dbPromise.then(db => {
            const tx = db.transaction('CF_Store', 'readwrite');
            var store = tx.objectStore('CF_Store');
            return store;
        });
    }

    deleteAll() {

        this.getAll().then(data => {

            for (var i = 0; i < data.length; i++) {
                this.delete(data[i].user_id);
            }
        });
    }

    setOrder(val, key) {
        return this.orderPromise.then(db => {
            const tx = db.transaction('order_store', 'readwrite');
            tx.objectStore('order_store').put(val, key);
            return tx.complete;
        });
    }

    getAllOrder() {
        return this.orderPromise.then(db => {
            var tx = db.transaction('order_store', 'readonly');
            var store = tx.objectStore('order_store');

            return store.getAll();
        });
    }

    getOrder(key) {

        return this.orderPromise
            .then(db => {
                var tx = db.transaction('order_store', 'readonly');
                var store = tx.objectStore('order_store');

                return store.openCursor(IDBKeyRange.only(key));

                //return tx.complete;
            });
    }

    deleteOrder(key) {

        return this.orderPromise.then(db => {
            const tx = db.transaction('order_store', 'readwrite');
            tx.objectStore('order_store').delete(key);
            tx.objectStore('order_store').getAll();

            return tx.complete;
        });
    }

    deleteAllOrder() {

        this.getAllOrder().then(data => {

            for (var i = 0; i < data.length; i++) {
                this.deleteOrder(data[i].cart_id);
            }
        });
    }

    async deleteAllCouponOrder(coupontype) {

        return this.getAllOrder().then(data => {

            for (var i = 0; i < data.length; i++) {


                if (data[i].product_discount_type == coupontype) {


                    this.deleteOrder(data[i].cart_id);
                }


            }


        });
    }
}

export default DB;


// WEBPACK FOOTER //
// ./src/dbconn.js